import { useSearchParams } from 'react-router-dom';

export default function useNextPath(fallbackPath = '/') {
  const [search] = useSearchParams();
  return search.get('next_path') || fallbackPath;
}
